<template>
  <div>
    <div class="pb-2 mt-5">Message template by membership tier</div>
    <div class="row">
      <label for="membershipCode" class="pb-1">Membership code</label>
      <div class="col-4 pt-0">
        <multiselect
          id="membershipCode"
          v-model="membershipCodeSelected"
          :options="listMembershipCode"
          :class="{
            'input--select--error':
              isSubmit && error.errorByMembershipMessageTemplates,
          }"
        />
        <div
          v-if="isSubmit && error.errorByMembershipMessageTemplates"
          class="text-error"
        >
          {{ error.errorByMembershipMessageTemplates.message }}
        </div>
      </div>
      <div class="col-2 pt-0">
        <button
          class="btn btn-outline-success w-50 btn-add-product ml-auto"
          @click="addMembershipCode"
        >
          Add
        </button>
      </div>
    </div>
    <div
      class="message-by-membership-container p-3 mt-3"
      v-if="
        form.byMembershipMessageTemplates &&
        form.byMembershipMessageTemplates.length > 0
      "
    >
      <div class="mb-5">
        <v-expansion-panels v-model="panel" class="mt-2" multiple focusable>
          <v-expansion-panel
            v-for="(membership, index) in form.byMembershipMessageTemplates"
            :key="index"
            class="my-2 template-container mt-3"
            tabindex="-1"
            :id="'messageTemplate' + index"
          >
            <v-expansion-panel-header>
              <template>
                <div class="d-flex flex-row align-items-center">
                  <div>
                    <label
                      :for="'membershipCode_' + membership.membershipCode"
                      class="pb-2"
                      >Membership code</label
                    >
                    <input
                      :id="'membershipCode_' + membership.membershipCode"
                      type="text"
                      v-model="membership.membershipCode"
                      class="form-control"
                      disabled="disabled"
                    />
                  </div>
                  <div class="ml-auto mr-10">
                    <button
                      class="btn btn-outline-danger m-0"
                      @click="deleteMessageTemplateByMembership(index)"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <LineMessageTemplate
                v-if="form.isSentViaLine"
                :trigger-type="form.triggerType"
                :message-template="membership.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplateLineList
                "
                :index="index"
                :error="error"
                :is-submit="isSubmit"
                :data-id="'message-tooltip-line-' + membership.membershipCode"
                :identifier="membership.membershipCode"
                :is-focusable="true"
              />
              <SmsMessageTemplate
                v-if="form.isSentViaSms"
                :trigger-type="form.triggerType"
                :message-template="membership.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplateSmsList
                "
                :index="index"
                :is-submit="isSubmit"
                :data-id="'message-tooltip-sms-' + membership.membershipCode"
                :identifier="membership.membershipCode"
                :is-focusable="true"
              />
              <PushNotificationTemplate
                v-if="form.isSentViaPushNoti"
                :trigger-type="form.triggerType"
                :message-template="membership.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplatePushNotiList
                "
                :index="index"
                :error="error"
                :is-submit="isSubmit"
                :data-id="
                  'message-tooltip-push-noti-' + membership.membershipCode
                "
                :identifier="membership.membershipCode"
                :is-focusable="true"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import MembershipService from "services/api/membership.service";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";
import DefaultMessageTemplateData from "components/MessageTemplate/defaultMessageTemplateData";

export default {
  name: "MessageTemplateByMembership",
  components: {
    PushNotificationTemplate,
    SmsMessageTemplate,
    LineMessageTemplate,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      membershipCodeSelected: null,
      listMembershipCode: [],
      panel: [],
    };
  },
  mounted() {
    this.getMemberships();
    if (this.form.byMembershipMessageTemplates.length > 0) {
      this.form.byMembershipMessageTemplates.forEach((_, i) =>
        this.panel.push(i)
      );
    }
  },
  methods: {
    async getMemberships() {
      const param = {
        brand: this.form.brandCode,
      };
      await MembershipService.getMemberships(param)
        .then((res) => {
          const data = res.data;
          this.listMembershipCode = data.membershipTiers.map((m) => m.code);
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    addMembershipCode() {
      const isDuplicateCode = this.form.byMembershipMessageTemplates?.some(
        (membership) =>
          membership.membershipCode === this.membershipCodeSelected
      );

      if (isDuplicateCode) {
        let duplicateIndex = this.form.byMembershipMessageTemplates.findIndex(
          (membership) =>
            membership.membershipCode === this.membershipCodeSelected
        );

        this.$nextTick(() => {
          document.getElementById("messageTemplate" + duplicateIndex)?.focus();
        });
      } else {
        this.form.byMembershipMessageTemplates.push({
          membershipCode: this.membershipCodeSelected,
          messageTemplates: {
            ...DefaultMessageTemplateData,
            showPeriodInDays: null,
          },
        });
        this.$nextTick(() => {
          let index = this.form.byMembershipMessageTemplates.length - 1;
          this.panel.push(index);
          document.getElementById("messageTemplate" + index)?.focus();
        });

        this.membershipCodeSelected = null;
      }
    },
    deleteMessageTemplateByMembership(index) {
      this.form.byMembershipMessageTemplates.forEach((_, i) => {
        if (i === index) {
          this.form.byMembershipMessageTemplates.splice(index, 1);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.input--select--error {
  border: 1px solid red;
  border-radius: 5px;
}

.message-by-membership-container {
  border: 1px dashed #ccc;
  border-radius: 15px;
  margin-left: -20px !important;
  margin-right: -20px !important;
}

.template-container:focus {
  border: 4px solid #aac6fa;
  border-radius: 10px;
}
</style>
